import {ContextFormatter} from 'common/src/modules/shared/copilot/copilot.types';
import {CopilotContextKey} from 'common/src/modules/shared/copilot/bootstrap/bootstrap.types';
import {CLCopilotContext} from 'common/src/modules/shared/copilot/bootstrap/bootstrap.types';
import formatContextPage from 'common/src/modules/shared/copilot/utils/formatContextPage';

function formatConceptPlanContext(
  prevContext: CLCopilotContext | null,
  currentContext: CLCopilotContext,
): string | null {
  // whether we are in the concept plan page
  const _conceptPlanTabFormatter: ContextFormatter = (prevContext, currentContext) =>
    formatContextPage(
      CopilotContextKey.ConceptPlan,
      'campaign concept plan tab',
      prevContext,
      currentContext,
    );

  const formatters = [_conceptPlanTabFormatter, _conceptPlanDetailsFormatter];

  return formatters
    .map((formatter) => formatter(prevContext, currentContext))
    .filter(Boolean)
    .join('\n');
}

// for formatting the current concept plan
function _conceptPlanDetailsFormatter(
  prevContext: CLCopilotContext | null,
  currentContext: CLCopilotContext,
): string | null {
  const prevConceptPlanContext = prevContext?.entries[CopilotContextKey.ConceptPlan];
  const currentConceptPlanContext = currentContext.entries[CopilotContextKey.ConceptPlan];

  const prevConceptPlan = prevConceptPlanContext?.data.conceptPlan;
  const currentConceptPlan = currentConceptPlanContext?.data?.conceptPlan;

  if (prevConceptPlan === currentConceptPlan || !currentConceptPlan) {
    return null;
  }

  return `The current concept plan is:\n${JSON.stringify(currentConceptPlan)}`;
}

export default formatConceptPlanContext;
